export default __webpack_public_path__ + "static/media/comics.0cdeb411.png";